export default "__VITE_ASSET__CbsX51s5__"